import { render, staticRenderFns } from "./FlowCreateFormWizard.vue?vue&type=template&id=0cbf4e8d&"
import script from "./FlowCreateFormWizard.vue?vue&type=script&lang=ts&"
export * from "./FlowCreateFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./FlowCreateFormWizard.vue?vue&type=style&index=0&id=0cbf4e8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports